import { combineReducers } from "redux";
import {dataReducer} from "./Reducers";

//Combinaison des reducers en un seul reducer racine
const rootReducer = combineReducers({
 reducer:dataReducer
});

export default rootReducer;
